module.exports = __webpack_public_path__ + "img/28.b678cb71.jpg";